// extracted by mini-css-extract-plugin
export default {"footerBox":"footer_footerBox__7k-kv"};